import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=e632d970&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=e632d970&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e632d970",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e632d970')) {
      api.createRecord('e632d970', component.options)
    } else {
      api.reload('e632d970', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=e632d970&scoped=true&", function () {
      api.rerender('e632d970', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2b8DZu5Fk4WE6/JS/comp/SearchFilterTokens.vue"
export default component.exports